import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function About() {
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-198">
      <Header data-id="element-199" />
      <main className="pt-32 pb-20 px-10" data-id="element-200">
        <div className="max-w-[1400px] mx-auto" data-id="element-201">
          <h1 className="text-[#2C2416] text-[clamp(48px,6vw,64px)] font-light leading-[1.1] tracking-[-3px] mb-6 font-['Inter']" data-id="element-202">
            About <span className="text-[#D4A574]" data-id="element-203">Modern Commerce</span>
          </h1>
          <p className="text-[#8B7355] text-xl max-w-2xl mb-6 leading-relaxed font-['Inter']" data-id="element-204">
            A new agency built on 15 years of ecommerce experience. We help you
            choose the right platform, then design, develop, and support your
            store.
          </p>
          <p className="text-[#8B7355] text-xl max-w-2xl mb-10 leading-relaxed font-['Inter']" data-id="element-205">
            We're experts in wine ecommerce, but we work across industries. That
            cross-pollination matters - ideas that work in other sectors often
            translate to wine, and vice versa.
          </p>
          <a href="/contact" className="inline-block bg-[#2C2416] text-[#FAF7F2] px-9 py-[18px] rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#D4A574] font-['Inter']" data-id="element-206">
            Get In Touch
          </a>
        </div>
      </main>
      <Footer data-id="element-207" />
    </div>;
}